<template>
  <div>
    <!-- Message box -->
    <div
        v-if="message"
        :class="messageType"
        class="mt-24 fixed top-5 left-1/2 transform -translate-x-1/2 p-4 rounded-lg text-center shadow-lg text-black dark:bg-dark-box-bg dark:text-dark-text dark:border dark:border-dark-border transition-all duration-500"
        style="width: 90%; max-width: 1200px; z-index: 3000;"
    >
      {{ message }}
      <div
          class="z-5000 absolute bottom-0 left-0 h-1"
          :style="{ width: progress + '%', backgroundColor: getProgressColor(), borderRadius: '8px' }"
      ></div>
    </div>

    <!-- Przycisk do zmiany statusu -->
    <div v-if="isAuthenticated" class="fixed bottom-8 left-10 z-2000">
      <button
          @click="toggleStatus"
          :class="statusClass"
          :disabled="isDisabled"
          class="text-white p-4 rounded-full shadow-lg focus:outline-none relative transition-all duration-200 ease-in-out transform hover:scale-110 active:scale-95 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <PowerIcon class="h-6 w-6" />
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue';
import { PowerIcon } from '@heroicons/vue/24/solid';
import { useAuthStore } from '@/stores/authStore';
import driversService from '@/services/driversService';
import { useSessionStore } from '@/stores/useSessionStore';

export default defineComponent({
  components: {
    PowerIcon
  },
  setup() {
    const authStore = useAuthStore();
    const sessionStore = useSessionStore();
    if (authStore.isAuthenticated) {
        authStore.checkExpiration();
    }
    const isAuthenticated = computed(() => authStore.isAuthenticated);
    return { user: authStore.user, isAuthenticated, authStore, sessionStore };
  },
  data() {
    return {
      message: '',
      messageType: '',
      driver: {},
      progress: 0,
    };
  },
  computed: {
    status() {
      return this.authStore.driverStatus;
    },
    statusClass() {
      const statusColors = {
        NIEDOSTEPNY: 'bg-red-500 hover:bg-red-600',
        DOSTEPNY: 'bg-green-500 hover:bg-green-600',
        W_TRAKCIE: 'bg-orange-300 cursor-not-allowed',
        AWARIA: 'bg-gray-500 hover:bg-gray-600',
        PRZYJETE: 'bg-blue-500 hover:bg-blue-600',
      };
      return statusColors[this.status] || 'bg-gray-500';
    },
    isDisabled() {
      return this.status === 'W_TRAKCIE';
    },
  },
  created() {
    this.getDriverById();
  },
  mounted() {
    this.authStore.fetchDriverData(this.authStore.user.uid);
    this.getDriverById();
    this.refreshDriver();
  },
  beforeUnmount() {
    if (this.sessionStore.intervalId) {
      clearInterval(this.sessionStore.intervalId); // Oczyść interval, jeśli jest ustawiony
      this.sessionStore.intervalId = null; // Reset interval to prevent any issues if it tries to be cleared again
    }
  },
  methods: {
    refreshDriver() {
      this.sessionStore.startInterval(() => {
          try {
            this.authStore.fetchDriverData(this.authStore.user.uid);
            this.getDriverById();
          } catch (error) {
            console.error('Error refreshing driver:', error);
          }
        }, 10000);
    },
    getDriverById() {
      if (!this.user || !this.user.uid) return;

      driversService.getDriverById(this.user.uid)
        .then(response => {
          this.driver = response.data;
          this.status = response.data.driverStatus;
        })
        .catch(error => {
          console.error('Nie udało się pobrać kierowcy:', error);
        });
    },
    toggleStatus() {
      if (this.isDisabled) return; // Zabezpieczenie przed kliknięciem

      const previousStatus = this.status; // Zapisujemy aktualny status przed zmianą

      driversService.updateDriverStatus(this.user.uid)
        .then(() => {
          this.getDriverById(); // Pobieramy nowy status z API

          // Wyświetlamy wiadomość z NOWYM statusem, zakładając jego zmianę
          const newStatus = previousStatus === "DOSTEPNY" ? "NIEDOSTEPNY" : "DOSTEPNY";
          const messageType = newStatus === "DOSTEPNY" ? "success" : "error";

          this.authStore.fetchDriverData(this.authStore.user.uid);

          this.showMessage(`Zmieniono Twój Status na: ${newStatus}`, messageType);
        })
        .catch(error => {
          console.error('Błąd zmiany statusu:', error);
          this.showMessage('Nie można zmienić statusu!', 'error');
        });
    },
    showMessage(msg, type) {
      this.message = msg;
      this.messageType = type === "success" ? "bg-green-500 text-white" : "bg-red-500 text-white";
      this.progress = 0;

      const interval = 30;
      const duration = 3000;
      const step = 100 / (duration / interval);

      const progressInterval = setInterval(() => {
        this.progress += step;
        if (this.progress >= 100) {
          clearInterval(progressInterval);
          this.progress = 0;
          this.message = '';
          this.messageType = '';
        }
      }, interval);
    },
    getProgressColor() {
      return this.messageType === "bg-green-500 text-white" ? "#16a34a" : "#b91c1c";
    },
  }
});
</script>
